export default "__VITE_ASSET__BhTkXIL5__"